const cssViewportHeight = () => window.innerHeight * 0.01

export default cssViewportHeight
